// extracted by mini-css-extract-plugin
export default {"PortfolioEditAlert-ids":"PortfolioEditAlert_PortfolioEditAlert-ids__jncsk"};